import { useRouteParams } from "src/hooks/useRouteParams";
import { PlanBasedBidsTableV2 } from "src/routes/bids/plan-based-bid-package/components/PlanBasedBidsTableV2";
import { queryResult } from "src/utils";
import {
  BidContractPlanPricingPageV2_RevisionFragment,
  useBidContractPlanPricingPageV2Query,
} from "./BidContractPlanPricingPageV2.generated";

export function BidContractPlanPricingV2Page() {
  const { bidContractRevisionId } = useRouteParams<{ bidContractRevisionId: string }>();
  const query = useBidContractPlanPricingPageV2Query({ variables: { bidContractRevisionId } });
  return queryResult(query, ({ bidContractRevision }) => (
    <BidContractPlanPricingV2View bidContractRevision={bidContractRevision} />
  ));
}

type BidContractPlanPricingV2ViewProps = { bidContractRevision: BidContractPlanPricingPageV2_RevisionFragment };

function BidContractPlanPricingV2View(props: BidContractPlanPricingV2ViewProps) {
  const { bidContractRevision } = props;
  return (
    <PlanBasedBidsTableV2
      mode="view"
      bidPackage={bidContractRevision.bidPackageVersion!.bidPackage}
      bidContractRevision={bidContractRevision}
    />
  );
}
